<template>
    <div class="application" :style="`padding-top: ${is_weixin ? '0' : '0.88rem'}`">
        <Title title="使用申请" background="#1e2e45"></Title>
        <div class="application-content">
            <div class="application-content-item" v-for="(formItem, formKey) in renderForm" :key="formKey">
                <div v-if="formItem.type === 'input' && !formItem.isHide" :class="`application-content-input ${errorType === formItem.key ? 'application-content-input-error' : ''}`">
                    <div class="application-content-label">
                        <span v-if="formItem.require" class="application-content-label-require">*</span>
                        {{formItem.label}}
                    </div>
                    <div :class="`application-content-item-input ${errorType === formItem.key ? 'application-content-item-input-error' : ''}`">
                        <input v-model="formData[formItem.key]" type="text" :placeholder="formItem.placeholder" @input="hanldeInput($event, formItem)" @focus="handleFocus(formItem)" :maxlength="formItem.maxLength">
                    </div>
                </div>

                <div v-if="formItem.type === 'radio' && !formItem.isHide" :class="`application-content-radio ${errorType === formItem.key ? 'application-content-radio-error' : ''}`">
                    <div class="application-content-label">
                        <span v-if="formItem.require" class="application-content-label-require">*</span>
                        {{formItem.label}}
                    </div>
                    <div class="application-content-item-radio">
                        <div class="application-content-item-radioItem" v-for="(radioItem, radioKey) in formItem.options" :key="radioKey" @click="handleSelectRadio(formItem, radioItem)">
                            <div class="application-content-item-radioItem-image">
                                <img v-show="radioItem.value === formData[formItem.key]" src="../../assets/reserve/application/active.png" alt="">
                                <img v-show="radioItem.value !== formData[formItem.key]" src="../../assets/reserve/application/unactive.png" alt="">
                            </div>
                            <div :class="`application-content-item-radioItem-label ${radioItem.value === formData[formItem.key] ? 'application-content-item-radioItem-label-active' : ''}`">{{ radioItem.label }}</div>
                        </div>
                    </div>
                </div>

                <div v-if="formItem.type === 'address' && !formItem.isHide" :class="`application-content-address ${errorType === 'address' ? 'application-content-input-box-error' : ''}`">
                    <div class="application-content-label">
                        <span v-if="formItem.require" class="application-content-label-require">*</span>
                        {{formItem.label}}
                    </div>
                    <div class="application-content-item-address">
                        <div :class="`application-content-item-addressItem ${errorType === 'province' ? 'application-content-input-error' : ''}`" @click="handleSelectAddress('showProvince')">
                            <input :value="formData.province_name" type="text" readonly placeholder="请选择省">
                            <img src="../../assets/reserve/application/down.png" alt="">
                        </div>
                        <div :class="`application-content-item-addressItem ${errorType === 'city' ? 'application-content-input-error' : ''}`" @click="handleSelectAddress('showCity')">
                            <input :value="formData.city_name" type="text" readonly placeholder="请选择市">
                            <img src="../../assets/reserve/application/down.png" alt="">
                        </div>
                        <div :class="`application-content-item-addressItem ${errorType === 'area' ? 'application-content-input-error' : ''}`" @click="handleSelectAddress('showArea')">
                            <input :value="formData.area_name" type="text" readonly placeholder="请选择区/县">
                            <img src="../../assets/reserve/application/down.png" alt="">
                        </div>
                        <div :class="`application-content-item-addressItem ${errorType === 'address' ? 'application-content-item-input-error' : ''}`">
                            <input maxlength="100" v-model="formData.address" class="application-content-item-addressItem-area" type="text" placeholder="请输入详细地址" @input="hanldeInput($event, formItem)" @focus="handleFocus(formItem)">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="application-bottom" @click="handleSubmit">提交</div>

        <van-popup v-model="showProvince" position="bottom">
            <van-picker v-model="formData.province_code" title="请选择省" show-toolbar :columns="provinceColumns" @confirm="handleConfirm($event, 'showProvince')" @cancel="handleCancel('showProvince')" />
        </van-popup>

        <van-popup v-model="showCity" position="bottom">
            <van-picker v-model="formData.city_code" title="请选择市" show-toolbar :columns="cityColumns" @confirm="handleConfirm($event, 'showCity')" @cancel="handleCancel('showCity')" />
        </van-popup>

        <van-popup v-model="showArea" position="bottom">
            <van-picker v-model="formData.area_code" title="请选择区/县" show-toolbar :columns="areaColumns" @confirm="handleConfirm($event, 'showArea')" @cancel="handleCancel('showArea')" />
        </van-popup>

        <van-popup v-model="showSuccess" :close-on-click-overlay="false">
            <div class="application-success">
                <div class="application-success-title">提交成功~</div>
                <div class="application-success-content">{{applyCallbackData.desc}}</div>
                <img v-if="applyCallbackData.img" class="application-success-qrcode" :src="applyCallbackData.img" alt="">
                <!-- <div v-if="applyCallbackData.short_name" class="application-success-remark">{{applyCallbackData.short_name}}</div> -->
                <div class="application-success-bottom" @click="handleSuccess">好的，我知道了</div>
                <div class="application-success-line"></div>
                <img class="application-success-watermark" src="../../assets/reserve/application/success.png" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
let isGetArea = false
import Title from '../../components/title/title.vue'
import { is_weixin, isEmpty, throttleFnc } from '../../utils/common'
import { initRenderForm } from './config'
export default {
    components: {
        Title
    },
    data() {
        return {
            renderForm: initRenderForm,
            formData: {},
            showProvince: false,
            showCity: false,
            showArea: false,
            showSuccess: false,
            provinceColumns: [],
            cityColumns: [],
            areaColumns: [],
            is_weixin: is_weixin(),
            configData: {},
            errorType: "",
            applyCallbackData: {}
        }
    },
    mounted() {
        this.getConfig()
        this.getDistrictList('provinceColumns')
    },
    methods: {
        /**
            获取公共配置
            @param
            @return
        */
        getConfig() {
            this.$axios({
                url: '/mldyue/common/config',
                data: {
                }
            }).then((res) => {
                const renderForm = [...this.renderForm]
                const categoryOptions = res.data.map((item) => {
                    return {
                        label: item.cate_name,
                        value: item.cate_id
                    }
                })
                const typeOptions = res.data[0].type.map((item) => {
                    return {
                        label: item.type_name,
                        value: item.type_id
                    }
                })
                renderForm[1].options = categoryOptions
                renderForm[2].options = typeOptions
                this.renderForm = renderForm
                this.$set(this.formData, 'category', categoryOptions[0].value)
                this.configData = res.data
            })
        },
        /**
            获取区域数据
            @param { String } type 类型
            @param { String } code 地区code
            @return
        */
        getDistrictList(type, code) {
            if (type === 'areaColumns') {
                isGetArea = false
            }
            this.$axios({
                url: '/mldyue/common/district',
                data: {
                    code: code
                }
            }).then((res) => {
                if (type === 'areaColumns') {
                    isGetArea = true
                }
                this[type] = res.data.list.map((item) => {
                    return {
                        text: item.name,
                        value: item.code
                    }
                })
            })
        },
        /**
            输入框输入事件
            @param { Event } event 输入事件参数
            @param { Object } formItem 表单项
            @return
        */
        hanldeInput(event, formItem) {
            let value = event.target.value
            if (formItem.filterFnc && typeof formItem.filterFnc === 'function') {
                value = formItem.filterFnc(value)
            }
            this.$set(this.formData, formItem.key, value)
        },

        /**
            输入框获取焦点事件
            @param { Object } formItem 表单项
            @return
        */
        handleFocus(formItem) {
            if (this.errorType === formItem.key) {
                this.errorType = ""
            }
        },

        /**
            点击radio项时触发
            @param { Object } formItem 表单项
            @param { Object } radioItem 单选数据项
            @return
        */
        handleSelectRadio(formItem, radioItem) {
            if (this.formData[formItem.key] !== radioItem.value) {
                this.$set(this.formData, formItem.key, radioItem.value)
                if (formItem.key === 'category') {
                    for (let i = 0; i < this.configData.length; i++) {
                        const configItem = this.configData[i], renderFormItem = { ...this.renderForm[2] }
                        if (configItem.cate_id === radioItem.value) {
                            renderFormItem.options = configItem.type.map((item) => {
                                return {
                                    label: item.type_name,
                                    value: item.type_id
                                }
                            })
                            this.$set(this.renderForm, 2, renderFormItem)
                        }
                    }
                    const renderFormType = { ...this.renderForm[3] }
                    if (radioItem.value === '1') {
                        renderFormType.isHide = false
                    } else if (radioItem.value === '2') {
                        renderFormType.isHide = true
                    }
                    this.$set(this.renderForm, 3, renderFormType)
                    this.$set(this.formData, 'type', "")
                }
            }
            if (this.errorType === formItem.key) {
                this.errorType = ""
            }
        },
        /**
            处理选择地址事件
            @param { String } type 类型
            @return
        */
        handleSelectAddress(type) {
            if (type !== 'showProvince' && !this.formData.province_code) {
                this.$toast('请先选择省')
                return
            }
            if (type === 'showArea' && !this.formData.city_code) {
                this.$toast('请先选择市')
                return
            }
            this[type] = true
        },
        /**
            picker确认的回调
            @param { Event } event 回调参数
            @param { String } type 类型
            @return
        */
        handleConfirm(event, type) {
            const formData = { ...this.formData }
            switch (type) {
                case 'showProvince':
                    formData.province_code = event.value
                    formData.province_name = event.text
                    formData.city_code = ''
                    formData.city_name = ''
                    formData.area_code = ''
                    formData.area_name = ''
                    this.formData = formData
                    this.getDistrictList('cityColumns', event.value)
                    break
                case 'showCity':
                    formData.city_code = event.value
                    formData.city_name = event.text
                    formData.area_code = ''
                    formData.area_name = ''
                    this.formData = formData
                    this.getDistrictList('areaColumns', event.value)
                    break
                case 'showArea':
                    formData.area_code = event.value
                    formData.area_name = event.text
                    this.formData = formData
                    break

            }
            if (type.toLocaleLowerCase().indexOf(this.errorType) > -1) {
                this.errorType = ""
            }
            this[type] = false
        },
        /**
            弹出框取消事件
            @param { String } type 类型
            @return
        */
        handleCancel(type) {
            this[type] = false
        },

        /**
            处理提交事件
            @param 
            @return
        */
        handleSubmit: throttleFnc(function (callback) {
            try {
                const formData = { ...this.formData }
                for (let i = 0; i < this.renderForm.length; i++) {
                    const renderFormItem = this.renderForm[i]
                    if (renderFormItem.key === 'address') {
                        if (isEmpty(formData.province_code)) {
                            this.$toast('请选择省')
                            this.errorType = 'province'
                            callback()
                            return
                        }
                        if (isEmpty(formData.city_code)) {
                            this.$toast('请选择市')
                            this.errorType = 'city'
                            callback()
                            return
                        }
                        if (isEmpty(formData.area_code) && (this.areaColumns.length || !isGetArea)) {
                            this.$toast('请选择区/县')
                            this.errorType = 'area'
                            callback()
                            return
                        }
                        if (isEmpty(formData.address)) {
                            this.$toast('请输入详细地址')
                            this.errorType = 'address'
                            callback()
                            return
                        }
                    } else {
                        const value = formData[renderFormItem.key]
                        if (!renderFormItem.isHide && renderFormItem.require && isEmpty(value)) {
                            this.errorType = renderFormItem.key
                            this.$toast(renderFormItem.placeholder)
                            callback()
                            return
                        }
                        if (renderFormItem.validFnc && typeof renderFormItem.validFnc === 'function') {
                            if (!renderFormItem.validFnc(value)) {
                                this.errorType = renderFormItem.key
                                this.$toast(renderFormItem.message)
                                callback()
                                return
                            }
                        }
                    }
                }
                delete formData.province_name
                delete formData.city_name
                delete formData.area_name
                this.$axios({
                    url: '/mldyue/common/account-apply',
                    data: {
                        ...formData
                    },
                    headers: {
                        requestClient: '4'
                    }
                }).then((res) => {
                    this.$axios({
                        url: '/mldyue/common/qr-code',
                        data: {}
                    }).then((res) => {
                        this.applyCallbackData = res.data
                        this.$nextTick(() => {
                            this.showSuccess = true
                        })
                        callback()
                    }).catch(() => {
                        this.applyCallbackData = {
                            desc: "提交成功，您的申请我们已经收到，将在1个工作日内通知您申请结果，请耐心等待。"
                        }
                        this.$nextTick(() => {
                            this.showSuccess = true
                        })
                        callback()
                    })
                })
            } catch (err) {
                this.$toast('申请失败，请联系工作人员。')
                callback()
            }
        }),
        /**
            处理成功事件
            @param 
            @return
        */
        handleSuccess() {
            this.showSuccess = false
            this.formData = {}
            this.cityColumns = []
            this.areaColumns = []
            this.getConfig()
        }
    }

}
</script>

<style scoped lang="scss">
.application {
    padding-bottom: 0.44rem;
    min-height: 100%;
    background-color: #1e2e45;
    .van-popup--center {
        border-radius: 0.16rem;
    }
}
.application-content {
    padding: 0.5rem 0.32rem 0.46rem;
    border-radius: 0 0 0.32rem 0.32rem;
    background-color: #fff;
}
.application-content-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 0.9rem;
    border-bottom: 0.02rem solid #d3d3d4;
    transition: border 0.2s;
}
.application-content-label {
    width: 1.68rem;
    padding-right: 0.2rem;
    font-size: 0.3rem;
    line-height: 0.88rem;
    text-align: right;
    color: #000;
}
.application-content-label-require {
    color: #fd6060;
}

.application-content-item-input {
    flex: 1;
    height: 0.8rem;
}
.application-content-item-input > input {
    width: 100%;
    height: 100%;
    border: none;
    font-size: 0.3rem;
    line-height: 0.8rem;
    transition: color 0.2s;
}

.application-content-radio {
    display: flex;
    flex-direction: row;
    border-bottom: 0.02rem solid #d3d3d4;
    transition: border 0.2s;
}

.application-content-radio-error {
    border-color: #f86190;
}

.application-content-item-radio {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1;
}
.application-content-item-radioItem {
    height: 0.88rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 0.32rem;
}

.application-content-item-radioItem-image {
    width: 0.32rem;
    height: 0.32rem;
    margin-right: 0.16rem;
    > img {
        width: 100%;
        height: 100%;
    }
}

.application-content-item-radioItem-label {
    color: #333;
}

.application-content-item-radioItem-label-active {
    color: #0eb4d2;
}

.application-content-address {
    display: flex;
    flex-direction: row;
    border-bottom: 0.02rem solid #d3d3d4;
    transition: border 0.2s;
}

.application-content-item-address {
    flex: 1;
}

.application-content-item-addressItem {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    height: 0.88rem;
    border-bottom: 0.02rem solid #d3d3d4;
    transition: border 0.2s;
    > input {
        text-align: center;
        border: none;
        transition: color 0.2s;
    }
    > img {
        position: absolute;
        width: 0.32rem;
        height: 0.32rem;
        right: 0.32rem;
        top: 0;
        bottom: 0;
        margin: auto 0;
    }
    > .application-content-item-addressItem-area {
        width: 100%;
        text-align: left;
    }
}
.application-content-item-addressItem:last-child {
    border-bottom: none;
}

.application-bottom {
    width: 3.6rem;
    height: 0.88rem;
    margin: 0.64rem auto 0.44rem;
    border-radius: 0.16rem;
    text-align: center;
    line-height: 0.88rem;
    background-color: #0eb4d2;
    color: #fff;
}

.application-content-input-error,
.application-content-input-box-error {
    border-color: #f86190;
}

.application-success {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 5.58rem;
    //height: 3.2rem;
    border-radius: 0.16rem;
    background-color: #fff;
    .application-success-title {
        height: 0.88rem;
        text-align: center;
        line-height: 0.88rem;
    }
    .application-success-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        flex: 1;
        padding: 0 0.24rem 0.24rem;
        font-size: 0.24rem;
        text-align: center;
        line-height: 0.48rem;
        color: #000;
    }
    .application-success-qrcode {
        display: block;
        width: 3.2rem;
        min-height: 3.2rem;
        margin: auto;
    }
    .application-success-remark {
        margin: 0.16rem 0;
        text-align: center;
        color: #ff4d4f;
    }
    .application-success-bottom {
        height: 0.88rem;
        text-align: center;
        line-height: 0.88rem;
        color: #0eb4d2;
    }
    .application-success-line {
        position: absolute;
        left: 0.48rem;
        right: 0.48rem;
        bottom: 0.88rem;
        height: 0.02rem;
        background-color: #d3d3d4;
    }
    .application-success-watermark {
        position: absolute;
        width: 1.84rem;
        height: 1.84rem;
        left: 0;
        right: 0;
        top: 0.24rem;
        margin: 0 auto;
    }
}

.application {
    input::-webkit-input-placeholder {
        color: #999;
        transition: color 0.2s;
    }
    input:-moz-placeholder {
        /*Mozilla Firefox 4 to 8*/
        color: #999;
        transition: color 0.2s;
    }
    input::moz-placeholder {
        /*Mozilla Firefox 19+*/
        color: #999;
        transition: color 0.2s;
    }
    input:-ms-input-placeholder {
        /*Internet Explorer 10+*/
        color: #999;
        transition: color 0.2s;
    }
}

.application-content-item-input-error,
.application-content-input-error {
    > input {
        color: #f86190;
    }
    input::-webkit-input-placeholder {
        color: #f86190;
    }
    input:-moz-placeholder {
        /*Mozilla Firefox 4 to 8*/
        color: #f86190;
    }
    input::moz-placeholder {
        /*Mozilla Firefox 19+*/
        color: #f86190;
    }
    input:-ms-input-placeholder {
        /*Internet Explorer 10+*/
        color: #f86190;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/reserve/application.vue